(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-accessory-product"]) return;
  try {
    
  if (!customElements.get('bc-accessory-product')) {
    customElements.define('bc-accessory-product', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const track = this.querySelector('[data-accessory-track]');
        const thumbnails = Array.from(this.querySelectorAll('[data-accessory-thumb]'));
        const thumbGroup = this.querySelector('[data-accessory-thumbs]');
        const selectImage = (index) => {
          const target = Math.max(0, Math.min(thumbnails.length - 1, index));
          track.scrollTo({left: target * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        if (track && thumbnails.length) {
          thumbGroup.hidden = false;
          thumbnails.forEach((button, index) => button.addEventListener('click', () => selectImage(index)));
          track.addEventListener('scroll', () => {
            const index = Math.round(track.scrollLeft / track.clientWidth);
            thumbnails.forEach((button, position) => button.setAttribute('aria-pressed', String(position === index)));
          }, {passive: true});
          track.addEventListener('keydown', (event) => {
            if (event.target !== track) return;
            const index = Math.round(track.scrollLeft / track.clientWidth);
            let next;
            if (event.key === 'ArrowRight') next = index + 1;
            if (event.key === 'ArrowLeft') next = index - 1;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = thumbnails.length - 1;
            if (next !== undefined) { event.preventDefault(); selectImage(next); }
          });
        }
        const quantity = this.querySelector('input[name="quantity"]');
        const quantityButtons = Array.from(this.querySelectorAll('[data-accessory-quantity-change]'));
        const updateQuantity = () => quantityButtons.forEach((button) => {
          button.disabled = Number(button.dataset.accessoryQuantityChange) < 0 && Number(quantity.value) <= 1;
        });
        if (quantity) {
          quantityButtons.forEach((button) => {
            button.hidden = false;
            button.addEventListener('click', () => {
              if (!Number.isFinite(quantity.valueAsNumber) || quantity.valueAsNumber < 1) quantity.value = '1';
              if (Number(button.dataset.accessoryQuantityChange) > 0) quantity.stepUp();
              else if (quantity.valueAsNumber > 1) quantity.stepDown();
              quantity.dispatchEvent(new Event('change', {bubbles: true}));
            });
          });
          quantity.addEventListener('input', updateQuantity);
          quantity.addEventListener('change', updateQuantity);
          updateQuantity();
        }
        const selector = this.querySelector('[data-accessory-variant]');
        const price = this.querySelector('[data-accessory-price]');
        const addButton = this.querySelector('[data-accessory-add]');
        const purchaseForm = this.querySelector('form');
        const variantInput = purchaseForm?.querySelector('[name="id"]');
        const guardVariant = () => {
          if (variantInput?.value.trim()) return true;
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = addButton.dataset.unavailableLabel;
          }
          return false;
        };
        guardVariant();
        purchaseForm?.addEventListener('submit', event => {
          if (!guardVariant()) event.preventDefault();
        });
        if (selector && addButton) selector.addEventListener('change', () => {
          const option = selector.selectedOptions[0];
          const available = option.dataset.available === 'true' && Boolean(selector.value.trim());
          if (price) price.textContent = option.dataset.price;
          addButton.disabled = !available;
          addButton.textContent = available ? addButton.dataset.addLabel : addButton.dataset.unavailableLabel;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-header"]) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('.bc-header__mobile-nav a');if(link){link.closest('details').open=false;}});document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.bc-header__mobile[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus();});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-home"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('bc-fit-picker')){
    customElements.define('bc-fit-picker',class extends HTMLElement{
      connectedCallback(){
        if(this.dataset.initialized)return;
        this.dataset.initialized='true';
        const tabs=Array.from(this.querySelectorAll('[data-fit-tab]'));
        const panels=Array.from(this.querySelectorAll('[data-fit-panel]'));
        const select=(index,focus)=>{
          tabs.forEach((tab,position)=>{const active=position===index;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;panels[position].hidden=!active;});
          if(focus)tabs[index].focus();
        };
        tabs.forEach((tab,index)=>{
          tab.addEventListener('click',()=>select(index,false));
          tab.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();select(next,true);});
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bc-product-gallery')) {
    customElements.define('bc-product-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.panels = [...this.querySelectorAll('[data-gallery-panel]')];
        this.buttons = [...this.querySelectorAll('[data-gallery-thumbnail]')];
        if (!this.panels.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.index = 0;
        this.status = this.querySelector('[data-gallery-status]');
        this.track = this.querySelector('[data-gallery-track]');
        this.dataset.enhanced = '';
        this.querySelector('[data-gallery-thumbnails]')?.removeAttribute('hidden');
        this.show(0);
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.select(index), { signal });
          button.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.panels.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.panels.length) % this.panels.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.panels.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.select(next);
            this.buttons[next].focus({ preventScroll: true });
            this.buttons[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }, { signal });
        });
        this.track.addEventListener('pointerdown', event => {
          if (event.pointerType === 'touch') this.touchStart = { x: event.clientX, y: event.clientY };
        }, { signal });
        this.track.addEventListener('pointerup', event => {
          if (!this.touchStart) return;
          const x = event.clientX - this.touchStart.x;
          const y = event.clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(x) > 45 && Math.abs(x) > Math.abs(y)) this.select((this.index + (x < 0 ? 1 : -1) + this.panels.length) % this.panels.length);
        }, { signal });
        this.track.addEventListener('pointercancel', () => { this.touchStart = null; }, { signal });
      }
      show(index) {
        this.index = index;
        this.panels.forEach((panel, position) => { panel.hidden = position !== index; });
        this.buttons.forEach((button, position) => { button.setAttribute('aria-pressed', String(position === index)); });
        if (this.status) this.status.textContent = this.panels[index].dataset.imageStatus;
      }
      select(index) {
        if (index === this.index) return;
        this.show(index);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  if (!customElements.get('bc-product-purchase')) {
    customElements.define('bc-product-purchase', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const quantity = this.querySelector('input[name="quantity"]');
        const buttons = [...this.querySelectorAll('[data-quantity-change]')];
        const sync = () => {
          buttons.forEach(button => { button.disabled = Number(button.dataset.quantityChange) < 0 && Number(quantity.value) <= Number(quantity.min); });
        };
        buttons.forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => {
            if (!quantity.value || Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;
            else if (Number(button.dataset.quantityChange) > 0) quantity.stepUp();
            else quantity.stepDown();
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
          }, { signal });
        });
        quantity?.addEventListener('change', sync, { signal });
        if (quantity) sync();
        const section = this.closest('.bc-product');
        const purchaseForm = this.querySelector('form');
        const variantInput = purchaseForm?.querySelector('[name="id"]');
        const addButton = this.querySelector('[data-product-add]');
        const guardVariant = () => {
          if (variantInput?.value.trim()) return true;
          if (addButton) {
            addButton.disabled = true;
            addButton.querySelector('span').textContent = addButton.dataset.unavailableLabel;
          }
          return false;
        };
        guardVariant();
        purchaseForm?.addEventListener('submit', event => {
          if (!guardVariant()) event.preventDefault();
        }, { signal });
        this.querySelector('[data-product-variant]')?.addEventListener('change', event => {
          const selected = event.target.selectedOptions[0];
          const button = this.querySelector('[data-product-add]');
          const price = section?.querySelector('[data-product-price]');
          if (price) price.textContent = selected.dataset.price;
          if (button) {
            button.disabled = selected.dataset.available !== 'true' || !event.target.value.trim();
            button.querySelector('span').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
          }
          if (event.target.value.trim()) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', event.target.value);
            window.history.replaceState(window.history.state, '', url.toString());
          }
        }, { signal });
        section?.querySelector('[data-open-delivery]')?.addEventListener('click', event => {
          const target = section.querySelector(event.currentTarget.getAttribute('href'));
          if (target) target.open = true;
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
